module.exports = __webpack_public_path__ + "static/media/p2008coveri2.e1ee17de.jpg";